import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hidden lg:block w-next-nav fixed h-menu bg-next-dark-gray z-10" }
const _hoisted_2 = { class: "grid grid-rows-8 h-full" }
const _hoisted_3 = { class: "flex-grow grid grid-rows-8 row-span-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_ProfileMenuButton = _resolveComponent("ProfileMenuButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MenuButton, {
        to: {name:'Home', params: {id: _ctx.id}},
        "icon-class": "icon-home",
        tooltip: "Home"
      }, null, 8, ["to"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_MenuButton, {
          to: {name:'DettaglioSottoProgetto', params: {id: _ctx.id}},
          "icon-class": "icon-catena_verticale",
          tooltip: "Sottprogetto"
        }, null, 8, ["to"]),
        _createVNode(_component_MenuButton, {
          to: {name:'SottoProgettoListaFornitori', params: {id: _ctx.id}},
          "icon-class": "icon-documento_freccia",
          tooltip: "ODA"
        }, null, 8, ["to"]),
        _createVNode(_component_MenuButton, {
          to: {name:'SottoProgettoODV', params: {id: _ctx.id}},
          "icon-class": "icon-documento_freccia rotate-180",
          tooltip: "ODV"
        }, null, 8, ["to"]),
        _createVNode(_component_MenuButton, {
          to: {name:'SottoProgettoPianoFatturazione', params: {id: _ctx.id}},
          "icon-class": "icon-euro_frecce",
          tooltip: "Piano Fatturazione"
        }, null, 8, ["to"]),
        _createVNode(_component_MenuButton, {
          to: {name:'VersioniSottoProgetto', params: {id: _ctx.id}},
          "icon-class": "icon-orologio_freccia",
          tooltip: "Versioni"
        }, null, 8, ["to"]),
        _createVNode(_component_MenuButton, {
          to: {name:'SottoprogettoCostiRicavi', params: {id: _ctx.id}},
          "icon-class": "icon-opzioni",
          tooltip: "Costi/Ricavi"
        }, null, 8, ["to"]),
        _createVNode(_component_MenuButton, {
          to: {name:'SottoprogettoDocumentiFornitori', params: {id: _ctx.id}},
          "icon-class": "icon-graffetta",
          tooltip: "Documenti fornitori"
        }, null, 8, ["to"]),
        _createVNode(_component_ProfileMenuButton, {
          class: "row-start-8",
          notification: _ctx.meCounters?.notification_counter > 0
        }, null, 8, ["notification"])
      ])
    ])
  ]))
}